import React, { useState, useEffect } from "react"
import { Formik, Field } from "formik"

import { renderTextInput, ZipInput, FormikRadioGroup, stateOptions } from "components/forms/SharedInputs"
import { renderSelectInput } from "steps/lead-gen/LeadGenHelpers"

import * as Yup from "yup"



const NameFields = ({ values, handleSubmit, setFieldValue, errors, touched }) => {
  return (
    <>
      <li className="form__element half-size" key={`firstName`}>
        <Field name="firstName" type="text" label={`First Name*`}  component={renderTextInput} variant="filled" touched={touched.firstName && true ? "true" : ""} />
        {errors.firstName && <p className="error">{errors.firstName}</p>}
      </li>
      <li className="form__element half-size" key={`lastName`}>
        <Field name="lastName" type="text" label="Last Name*" placeholder={"Last Name"} component={renderTextInput}  variant="filled" touched={touched.lastName && true ? "true" : ""} />
        {errors.lastName && <p className="error">{errors.lastName}</p>}
      </li>
    </>
  )
}

const AddressFields = ({ values, handleSubmit, setFieldValue, errors, touched }) => {

  return (
    <>
      <li className="form__element" key={`address`}>
        <Field name={"address1"} type="text" label={`Address Line 1*`} variant="filled" component={renderTextInput} />
        {errors.address1 && <p className="error">{errors.address1}</p>}
      </li>
      <li className="form__element" key={`address2`}>
        <Field name={"address2"} type="text" label={`Address Line 2`} variant="filled" component={renderTextInput} />
        {errors.address2 && <p className="error">{errors.address2}</p>}
      </li>
      <li className="form__element third-size" key={`city`}>
        <Field name={"city"} type="text" label={`City*`} variant="filled" component={renderTextInput} />
        {errors.city && <p className="error">{errors.city}</p>}
      </li>
      <li className="form__element third-size" key={`state`}>
        <Field name={"state"} type="text" label={`State*`} variant="filled" component={renderSelectInput} options={stateOptions} />
        {errors.state && <p className="error">{errors.state}</p>}
      </li>
      <li className="form__element third-size" key={`zip`}>
        <Field name={"postalCode"} type="text" label={`Postal Code*`} component={ZipInput} />

        {errors.postalCode && <p className="error">{errors.postalCode}</p>}
      </li>
    </>
  )
}
export {AddressFields, NameFields}